/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Processing_JobInputs */

const en_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing Job`)
};

const fr_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement de la tache`)
};

const de_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitungsauftrag`)
};

const it_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione del lavoro`)
};

const ru_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка задания`)
};

const es_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo de procesamiento`)
};

const zh_cn2_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理作业`)
};

const ja_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理ジョブ`)
};

const hi_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्य प्रक्रिया`)
};

const pt_pt2_embed_captions_processing_job = /** @type {(inputs: Embed_Captions_Processing_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa de processamento`)
};

/**
* | output |
* | --- |
* | "Processing Job" |
*
* @param {Embed_Captions_Processing_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_processing_job = /** @type {((inputs?: Embed_Captions_Processing_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Processing_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_processing_job(inputs)
	if (locale === "de") return de_embed_captions_processing_job(inputs)
	if (locale === "it") return it_embed_captions_processing_job(inputs)
	if (locale === "ru") return ru_embed_captions_processing_job(inputs)
	if (locale === "es") return es_embed_captions_processing_job(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_processing_job(inputs)
	if (locale === "ja") return ja_embed_captions_processing_job(inputs)
	if (locale === "hi") return hi_embed_captions_processing_job(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_processing_job(inputs)
	return en_embed_captions_processing_job(inputs)
});